import React, { useCallback, useEffect, useState } from "react";
import css from "./SurveyDocument.module.scss";
import { listenDb, offListenDb } from "@/js/firebase";

import { getUrlParam } from "@/js/functions";

type Props = {};

const SurveyDocument = (props: Props) => {
  const [list, setlist] = useState();
  const symposiumId = getUrlParam(0);
  const meetingId = getUrlParam(1);
  const [answeredQuestions, setansweredQuestions] = useState();
  const [displayList, setdisplayList] = useState();

  // 参考資料をリッスン
  useEffect(() => {
    const path = `${symposiumId}/realtimeSurveyDocument/${meetingId}`;

    listenDb(`${symposiumId}/realtimeSurveyDocument/${meetingId}`, (res) => {
      setlist(res);
    });

    return () => {
      offListenDb(path);
    };
  }, []);

  // ヘッダーハンバーガーのチェックボックスの変更を監視
  useEffect(() => {
    const headerNavCheckbox = document.getElementById("hbgCheckbox");

    const handler = (e) => {
      if (e.target.checked) {
        const _tmp = JSON.parse(localStorage.getItem("questionnaireList"));
        setansweredQuestions(_tmp);
      }
    };

    headerNavCheckbox?.addEventListener("change", handler);

    return () => {
      headerNavCheckbox?.removeEventListener("change", handler);
    };
  }, []);

  useEffect(() => {
    if (answeredQuestions && list) {
      const tmp = Object.keys(list)?.filter((key) => {
        return answeredQuestions?.find((questionId) => questionId === key);
      });

      setdisplayList(tmp);
    }
  }, [answeredQuestions, list]);

  const setSheetUrl = (obj) => {
    document.body.dataset.sheetUrl = createSurveyDocumentUrl(
      obj.url,
      obj.name,
      obj?.enableDownload
    );
  };

  if (!displayList || displayList.length === 0) {
    return null;
  }

  return (
    <ul className={`${css["comp"]}`}>
      <li className={`${css["head"]}`}>参考資料</li>
      {displayList?.map((key) => {
        return (
          <li
            key={key}
            className={css["item"]}
            onClick={() => {
              setSheetUrl(list[key]);
            }}
          >
            {list[key].name || `参考資料`}
          </li>
        );
      })}
    </ul>
  );
};

export default SurveyDocument;
